import script from "./icon-tow-tones-bitcoin.vue?vue&type=script&lang=ts&setup=true"
export * from "./icon-tow-tones-bitcoin.vue?vue&type=script&lang=ts&setup=true"

import "./icon-tow-tones-bitcoin.vue?vue&type=style&index=0&id=b61a551a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b61a551a"]])

export default __exports__